import { ReactNode, memo } from 'react';
import {
  AppMenuDivider,
  AppMenuItemContainer,
  StyledMenu,
  StyledMenuTitle,
  ButtonLogo,
} from './AppMenu.styles';
import { AppMenuItem } from './AppMenuItem';
import { AppMenuContentProps } from '../models/MenuContentProps';
import { nanoid } from 'nanoid';
import { PrismaBrand } from './PrismaBrand';
import { useNavigate } from 'react-router-dom';
import { HOME_PATH } from 'navigation/routes';

function getMenuItem(item: AppMenuContentProps): ReactNode {
  switch (item.itemType) {
    case 'divider':
      return (
        <AppMenuItemContainer
          key={nanoid()}
          style={{
            padding: 8,
          }}
        >
          <AppMenuDivider />
        </AppMenuItemContainer>
      );
    case 'title':
      return (
        <AppMenuItemContainer
          key={nanoid()}
          style={{
            padding: '12px 8px 4px',
          }}
        >
          <StyledMenuTitle>{item.text}</StyledMenuTitle>
        </AppMenuItemContainer>
      );
    case 'menuItem':
      return (
        <AppMenuItemContainer key={nanoid()}>
          <AppMenuItem item={item} />
        </AppMenuItemContainer>
      );
    default:
      return <></>;
  }
}

/**
 * Este componente reemplaza al menu de orbita. Esta construido de la misma forma a nivel estilos, pero esta integrado con el router,
 * es decir que al hacer click en un item redirecciona a la ruta que posee ese item
 */
export const AppMenu = memo(
  ({
    menu,
    showBrand,
    fullHeight,
  }: {
    menu: AppMenuContentProps[];
    showBrand?: boolean;
    fullHeight?: boolean;
  }) => {
    const navigate = useNavigate();

    return (
      <StyledMenu $fullHeight={fullHeight}>
        {showBrand && (
          <AppMenuItemContainer
            style={{
              padding: '12px 8px',
            }}
          >
            <ButtonLogo onClick={() => navigate(HOME_PATH)}>
              <PrismaBrand />
            </ButtonLogo>
          </AppMenuItemContainer>
        )}
        <ul
          style={{
            paddingTop: showBrand ? 24 : 0,
          }}
        >
          {menu.map((item) => getMenuItem(item))}
        </ul>
      </StyledMenu>
    );
  },
);
